<template>
    <ElementLayout :parent="parent" :element="element">
        <UserChooser v-model="element.value" :label="element.title" :disabled="element.disabled" :hide-details="true" :single-line="false" />
    </ElementLayout>
</template>

<script>
import ElementLayout from '../ElementLayout' 
import UserChooser from '../../ui-elements/UserChooser'

export default {
    data() {
        return {
        
        }
    },

    components: {
        ElementLayout,
        UserChooser,
    },
    
    props: {
        element: Object,
        parent: Object,
    },

    computed: {
        attributes() {

        }
    },

    methods: {
        function1() {

        },
    },
}
</script>

<style scoped>
   
</style>




// WEBPACK FOOTER //
// SelectUserControl.vue?47f02662